// extracted by css-extract-rspack-plugin
export default {"orderDetailItem":"orderDetailItem-HlswS4","chirpLink":"chirpLink-naKrCx"};